const flamengo = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 26/27 - Uniforme 1",
    aliases: ["flamengo", "mengão", "2026", "2026 flamengo", "flamengo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/26-27-01/uni0.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01/uni1.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01/uni2.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01/uni3.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 26/27 - Uniforme de Treino (Marron)",
    aliases: ["flamengo", "mengão", "2026", "2026 flamengo", "flamengo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/26-27-05-tm/uni0.jpg",
      "/images/brasil/serie-a/flamengo/26-27-05-tm/uni1.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 26/27 - Uniforme de Treino (Branca)",
    aliases: ["flamengo", "mengão", "2026", "2026 flamengo", "flamengo 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/26-27-05-tb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/26-27-05-tb/uni1.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 26/27 - Uniforme 1 (Feminino)",
    aliases: [
      "flamengo",
      "mengão",
      "2026",
      "2026 flamengo",
      "flamengo 2026",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/26-27-01-f/uni0.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01-f/uni1.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01-f/uni2.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01-f/uni3.jpg",
      "/images/brasil/serie-a/flamengo/26-27-01-f/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 2 (Feminino)",
    aliases: [
      "flamengo",
      "mengão",
      "2025",
      "2025 flamengo",
      "flamengo 2025",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-02-f/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-f/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-f/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-f/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-f/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 3 (Feminino)",
    aliases: [
      "flamengo",
      "mengão",
      "2025",
      "2025 flamengo",
      "flamengo 2025",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-03-f/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03-f/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03-f/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03-f/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03-f/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme Edição Especial",
    aliases: [
      "flamengo",
      "mengão",
      "2025",
      "2025 flamengo",
      "flamengo 2025",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-00-esf/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-esf/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-esf/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-esf/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-esf/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme Edição Especial",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-00-es/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-es/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-es/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-es/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 1",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 1 Manga Longa",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-01-mc/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01-mc/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01-mc/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01-mc/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-01-mc/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Calção 2",
    aliases: [
      "flamengo",
      "mengão",
      "2025",
      "2025 flamengo",
      "flamengo 2025",
      "calção",
      "calção flamengo",
      "flamengo calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-02-c/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-c/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-c/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-c/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-02-c/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme 3",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme de Pré Jogo (Bege)",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-05-pjb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjb/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjb/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjb/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjb/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme de Pré Jogo (Vermelha/Preta)",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-05-pjrn/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjrn/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjrn/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjrn/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-pjrn/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme Retro",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-05-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-05-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 25/26 - Uniforme Retro",
    aliases: ["flamengo", "mengão", "2025", "2025 flamengo", "flamengo 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/25-26-06-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/25-26-06-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/25-26-06-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/25-26-06-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/25-26-06-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme 1",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme 3",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-03/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-03/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-03/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-03/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme de Treino (Branca)",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-05-tb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tb/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tb/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tb/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tb/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme de Treino (Cinza)",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-05-tc/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tc/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tc/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tc/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-05-tc/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme Edição Especial",
    aliases: ["flamengo", "mengão", "2024", "2024 flamengo", "flamengo 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-00-esb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-00-esb/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-00-esb/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-00-esb/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-00-esb/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Jaqueta (Vermelha/Branca)",
    aliases: [
      "flamengo",
      "mengão",
      "2024",
      "2024 flamengo",
      "flamengo 2024",
      "jaqueta flamengo",
      "flamengo jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-09-jvb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-09-jvb/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-09-jvb/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-09-jvb/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-09-jvb/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Regata",
    aliases: [
      "flamengo",
      "mengão",
      "2024",
      "2024 flamengo",
      "flamengo 2024",
      "regata flamengo",
      "flamengo regata",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-01-re/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-re/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-re/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-re/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-re/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme 1 (Feminino)",
    aliases: [
      "flamengo",
      "mengão",
      "2024",
      "2024 flamengo",
      "flamengo 2024",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-01-f/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-f/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-f/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-f/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-01-f/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 24/25 - Uniforme 2 (Feminino)",
    aliases: [
      "flamengo",
      "mengão",
      "2024",
      "2024 flamengo",
      "flamengo 2024",
      "feminino flamengo",
      "flamengo feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/24-25-02-f/uni0.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02-f/uni1.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02-f/uni2.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02-f/uni3.jpg",
      "/images/brasil/serie-a/flamengo/24-25-02-f/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 23/24 - Jaqueta (Vermelha)",
    aliases: [
      "flamengo",
      "mengão",
      "2023",
      "2023 flamengo",
      "flamengo 2023",
      "jaqueta flamengo",
      "flamengo jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/23-24-09-jv/uni0.jpeg",
      "/images/brasil/serie-a/flamengo/23-24-09-jv/uni1.jpeg",
      "/images/brasil/serie-a/flamengo/23-24-09-jv/uni2.jpeg",
      "/images/brasil/serie-a/flamengo/23-24-09-jv/uni3.jpeg",
      "/images/brasil/serie-a/flamengo/23-24-09-jv/uni4.jpeg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 23/24 - Jaqueta (Preta)",
    aliases: [
      "flamengo",
      "mengão",
      "2023",
      "2023 flamengo",
      "flamengo 2023",
      "jaqueta flamengo",
      "flamengo jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/23-24-09-jp1/uni0.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp1/uni1.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp1/uni2.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp1/uni3.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp1/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 23/24 - Jaqueta (Preta)",
    aliases: [
      "flamengo",
      "mengão",
      "2023",
      "2023 flamengo",
      "flamengo 2023",
      "jaqueta flamengo",
      "flamengo jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/23-24-09-jp/uni0.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp/uni1.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp/uni2.jpg",
      "/images/brasil/serie-a/flamengo/23-24-09-jp/uni3.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 23/24 - Uniforme de Treino (Branco)",
    aliases: ["flamengo", "mengão", "2023", "2023 flamengo", "flamengo 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/23-24-05-tb/uni0.jpg",
      "/images/brasil/serie-a/flamengo/23-24-05-tb/uni1.jpg",
      "/images/brasil/serie-a/flamengo/23-24-05-tb/uni2.jpg",
      "/images/brasil/serie-a/flamengo/23-24-05-tb/uni3.jpg",
      "/images/brasil/serie-a/flamengo/23-24-05-tb/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 22/23 - Uniforme 1",
    aliases: ["flamengo", "mengão", "2022", "2022 flamengo", "flamengo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/22-23-01/uni0.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01/uni1.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01/uni2.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01/uni3.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 22/23 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2022", "2022 flamengo", "flamengo 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/22-23-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/22-23-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/22-23-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/22-23-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 22/23 - Regata 1",
    aliases: [
      "flamengo",
      "mengão",
      "2022",
      "2022 flamengo",
      "flamengo 2022",
      "regata",
      "flamengo regata",
      "regata flamengo",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/22-23-01-re/uni0.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01-re/uni1.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01-re/uni2.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01-re/uni3.jpg",
      "/images/brasil/serie-a/flamengo/22-23-01-re/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 21/22 - Uniforme 1",
    aliases: ["flamengo", "mengão", "2021", "2021 flamengo", "flamengo 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/21-22-01/uni0.jpg",
      "/images/brasil/serie-a/flamengo/21-22-01/uni1.jpg",
      "/images/brasil/serie-a/flamengo/21-22-01/uni2.jpg",
      "/images/brasil/serie-a/flamengo/21-22-01/uni3.jpg",
      "/images/brasil/serie-a/flamengo/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 21/22 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2021", "2021 flamengo", "flamengo 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/21-22-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/21-22-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/21-22-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/21-22-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 21/22 - Uniforme 3",
    aliases: ["flamengo", "mengão", "2021", "2021 flamengo", "flamengo 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/flamengo/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/flamengo/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/flamengo/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/flamengo/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 21/22 - Uniforme Edição Especial",
    aliases: ["flamengo", "mengão", "2021", "2021 flamengo", "flamengo 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/21-22-00-esr/uni0.jpg",
      "/images/brasil/serie-a/flamengo/21-22-00-esr/uni1.jpg",
      "/images/brasil/serie-a/flamengo/21-22-00-esr/uni2.jpg",
      "/images/brasil/serie-a/flamengo/21-22-00-esr/uni3.jpg",
      "/images/brasil/serie-a/flamengo/21-22-00-esr/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 21/22 - Jaqueta (Preta)",
    aliases: [
      "flamengo",
      "mengão",
      "2021",
      "2021 flamengo",
      "flamengo 2021",
      "jaqueta flamengo",
      "flamengo jaqueta",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/21-22-09-jp/uni0.jpg",
      "/images/brasil/serie-a/flamengo/21-22-09-jp/uni1.jpg",
      "/images/brasil/serie-a/flamengo/21-22-09-jp/uni2.jpg",
      "/images/brasil/serie-a/flamengo/21-22-09-jp/uni3.jpg",
      "/images/brasil/serie-a/flamengo/21-22-09-jp/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 20/21 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2020", "2020 flamengo", "flamengo 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/20-21-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/20-21-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/20-21-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/20-21-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 19/20 - Uniforme 2",
    aliases: ["flamengo", "mengão", "2019", "2019 flamengo", "flamengo 2019"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/19-20-02/uni0.jpg",
      "/images/brasil/serie-a/flamengo/19-20-02/uni1.jpg",
      "/images/brasil/serie-a/flamengo/19-20-02/uni2.jpg",
      "/images/brasil/serie-a/flamengo/19-20-02/uni3.jpg",
      "/images/brasil/serie-a/flamengo/19-20-02/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 18/19 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/18-19-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/18-19-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/18-19-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/18-19-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/18-19-01-rt/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 17/18 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/17-18-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/17-18-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/17-18-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/17-18-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/17-18-01-rt/uni4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 15/16 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/15-16-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/15-16-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/15-16-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/15-16-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/15-16-02-rt/uni4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 10/11 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/10-11-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/10-11-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/10-11-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/10-11-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/10-11-02-rt/uni4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 09/10 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/09-10-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/09-10-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/09-10-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/09-10-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/09-10-01-rt/uni4.jpg",
    ],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 08/09 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/08-09-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/08-09-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/08-09-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/08-09-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/08-09-01-rt/uni4.jpg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 08/09 - Uniforme Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/08-09-05-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/08-09-05-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/08-09-05-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/08-09-05-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/08-09-05-rt/uni4.jpg",
    ],
  },
  {
    id: 49,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 03/04 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/03-04-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/03-04-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/03-04-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/03-04-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/03-04-01-rt/uni4.jpg",
    ],
  },
  {
    id: 50,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 00/01 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/00-01-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/00-01-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/00-01-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/00-01-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 51,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 99/00 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/99-00-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/99-00-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/99-00-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/99-00-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/99-00-01-rt/uni4.jpg",
    ],
  },
  {
    id: 52,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 99/00 - Uniforme 3 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/99-00-03-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/99-00-03-rt/uni1.jpeg",
      "/images/brasil/serie-a/flamengo/99-00-03-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/99-00-03-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/99-00-03-rt/uni4.jpg",
    ],
  },
  {
    id: 53,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 99/00 - Uniforme de Goleiro (Azul) Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/99-00-05-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/99-00-05-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/99-00-05-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/99-00-05-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/99-00-05-rt/uni4.jpg",
    ],
  },
  {
    id: 54,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 97/98 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/97-98-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/97-98-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/97-98-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/97-98-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 55,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 97/98 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/97-98-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/97-98-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/97-98-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/97-98-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 56,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 95/96 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/95-96-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/95-96-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/95-96-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/95-96-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/95-96-02-rt/uni4.jpg",
    ],
  },
  {
    id: 57,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 95/96 - Uniforme 3 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/95-96-03-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/95-96-03-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/95-96-03-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/95-96-03-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/95-96-03-rt/uni4.jpg",
    ],
  },
  {
    id: 58,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 94/95 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/94-95-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/94-95-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/94-95-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/94-95-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/94-95-01-rt/uni4.jpg",
    ],
  },
  {
    id: 59,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 92/93 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/92-93-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/92-93-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/92-93-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/92-93-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/92-93-01-rt/uni4.jpg",
    ],
  },
  {
    id: 60,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 86/87 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/86-87-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/86-87-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/86-87-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/86-87-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/86-87-01-rt/uni4.jpg",
    ],
  },
  {
    id: 61,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 86/87 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/86-87-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/86-87-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/86-87-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/86-87-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/86-87-02-rt/uni4.jpg",
    ],
  },
  {
    id: 62,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 81/82 - Uniforme 2 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/81-82-02-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/81-82-02-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/81-82-02-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/81-82-02-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/81-82-02-rt/uni4.jpg",
    ],
  },
  {
    id: 62,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo 78/79 - Uniforme 1 Retro",
    aliases: [
      "flamengo",
      "mengão",
      "retro",
      "retro flamengo",
      "flamengo retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/flamengo/78-79-01-rt/uni0.jpg",
      "/images/brasil/serie-a/flamengo/78-79-01-rt/uni1.jpg",
      "/images/brasil/serie-a/flamengo/78-79-01-rt/uni2.jpg",
      "/images/brasil/serie-a/flamengo/78-79-01-rt/uni3.jpg",
      "/images/brasil/serie-a/flamengo/78-79-01-rt/uni4.jpg",
    ],
  },
  {
    id: 63,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo - Jaqueta (Preta)",
    aliases: [
      "flamengo",
      "mengão",
      "jaqueta",
      "jaqueta flamengo",
      "flamengo jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/jp/uni0.jpg",
      "/images/brasil/serie-a/flamengo/jp/uni1.jpg",
      "/images/brasil/serie-a/flamengo/jp/uni2.jpg",
      "/images/brasil/serie-a/flamengo/jp/uni3.jpg",
      "/images/brasil/serie-a/flamengo/jp/uni4.jpg",
    ],
  },
  {
    id: 64,
    pais: "brasil",
    liga: "serie-a",
    time: "flamengo",
    nome: "Flamengo - Jaqueta (Vermelha)",
    aliases: [
      "flamengo",
      "mengão",
      "jaqueta",
      "jaqueta flamengo",
      "flamengo jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/flamengo/jv/uni0.jpg",
      "/images/brasil/serie-a/flamengo/jv/uni1.jpg",
      "/images/brasil/serie-a/flamengo/jv/uni2.jpg",
      "/images/brasil/serie-a/flamengo/jv/uni3.jpg",
      "/images/brasil/serie-a/flamengo/jv/uni4.jpg",
    ],
  },
];
export default flamengo;
